module.exports = __webpack_public_path__ + "img/noresult.9da2d7e2.png";